/**
 *
 * Asynchronously loads the component for PreSessionAssessment
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
